// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CloudIconSignature {
  Element: SVGSVGElement;
}

export const CloudIcon: TOC<CloudIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7 19H15C18.859 19 22 15.86 22 12C22 8.141 18.859 5 15 5C12.141 5 9.642 6.699 8.563 9.254C8.061 9.086 7.533 9 7 9C4.243 9 2 11.243 2 14C2 16.757 4.243 19 7 19ZM4 14C4 12.346 5.346 11 7 11C7.57 11 8.131 11.166 8.618 11.48C8.892 11.658 9.234 11.689 9.535 11.567C9.838 11.445 10.061 11.183 10.135 10.867C10.662 8.59 12.663 7 15 7C17.757 7 20 9.243 20 12C20 14.757 17.757 17 15 17H7C5.346 17 4 15.654 4 14Z"/>
</svg>
</template>;